export const translations = {
	'API key': {
		no: 'API nøkkel',
	},
	'API secret': {
		no: 'API secret',
	},
	'Authentication server': {
		en: 'Auth server',
		no: 'Auth server',
	},
	'Token server': {
		no: 'Token server',
	},
	'Scope': {
		no: 'Scope',
	},
	'Authentication protocol': {
		no: 'Autentiseringsprotokoll',
	},
	'Privacy protocol': {
		no: 'Personvernprotokoll',
	},
	'Validate start message': {
		en: 'Click validate button to start the validation process',
		no: 'Klikk på valider knappen for å starte valideringsprosessen',
	},
	'Valid authentication': {
		en: 'Authentication of current configuration is validated',
		no: 'Autentisering av gjeldende konfigurasjon er validert',
	},
	'Valid authentication changed': {
		en: 'Authentication configuration has been changed. New configuration should be validated before update',
		no: 'Autentisert konfigurasjon er endret. Ny konfigurasjon bør valideres før oppdatering',
	},
	'Code expires': {
		en: 'The code expires on {0}',
		no: 'Koden utløper {0}',
	},
	'Oauth needs validation': {
		en: 'You need to validate the Oauth-2 after create. Follow the instructions in the next screen',
		no: 'Du må validere Oauth-2 etter opprettelse. Følg instruksjonene i neste skjerm',
	},
	'Clear field': {
		no: 'Tøm felt',
	},
};
